import { gsap } from 'gsap';

export function buttons() {
	gsap.utils.toArray('.js-button').forEach((button) => {
		const text = button.querySelector('.js-text');
		const timeline = gsap.timeline({ paused: true, reversed: true });

		timeline.to(text, {
			yPercent: -100,
			duration: 0.3,
			ease: 'power1.inOut',
		});

		button.addEventListener('mouseenter', () => {
			timeline.play();
		});

		button.addEventListener('mouseleave', () => {
			timeline.reverse();
		});
	});
}
